import Vue from 'vue'
import Router from 'vue-router'
import Orders from '@/components/Orders'
import OpenOrders from '@/components/OpenOrders'
import Login from '@/components/Login'
import Stocks from '@/components/Stocks'
import ArticlesBoughtListing from '@/components/ArticlesBoughtListing'
import StockHistory from '@/components/StockHistory'
import AdminUsers from '@/components/AdminUsers'
import AdminArticleAmazonMapping from '@/components/AdminArticleAmazonMapping'
import AdminArticleShopMapping from '@/components/AdminArticleShopMapping'
import Dashboard from '@/components/Dashboard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    /*{
      path: '/orders/:id',
      name: 'OrderShow',
      component: OrderShow
    },*/
    {
      path: '/open_orders',
      name: 'OpenOrders',
      component: OpenOrders
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/stocks',
      name: 'Stocks',
      component: Stocks
    },
    {
      path: '/articles_bought',
      name: 'ArticlesBoughtListing',
      component: ArticlesBoughtListing
    },
    {
      path: '/stock_history',
      name: 'StockHistory',
      component: StockHistory
    },
    {
      path: '/admin_users',
      name: 'AdminUsers',
      component: AdminUsers
    },
    {
      path: '/admin_article_amazon_mapping',
      name: 'AdminArticleAmazonMapping',
      component: AdminArticleAmazonMapping
    },
    {
      path: '/admin_article_shop_mapping',
      name: 'AdminArticleShopMapping',
      component: AdminArticleShopMapping
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js